import DisciplineDetail from "@/pages/DisciplineDetail";

export default function GinnasticaPosturale() {
  return <DisciplineDetail slug="ginnastica-posturale" />;
}
